import { dcmConstants } from './../_constants';

export function listDcmsReducer(state = {}, action) {
  switch ( action.type ) {
    case 'LIST_DCM_SUCCESS':
      return {
        dcms: {
          type: action.type,
          message: action.data
        }
      }
    case 'LIST_DCM_FAILURE':
      return {
        dcms: {
          type: action.type,
          message: action.data
        }
      }
    default:
      return {
        dcms: (!state.dcms ? {} : state.dcms)
      }
  }
}

export function createDcmReducer(state = {}, action) {
  switch ( action.type ) {
    case 'CREATE_DCM_SUCCESS':
      return {
        dcm: {
          type: action.type,
          message: action.data
        }
      }
    case 'CREATE_DCM_FAILURE':
      return {
        dcm: {
          type: action.type,
          message: action.data
        }
      }
    default:
      return {
        dcm: (!state.dcm ? {} : state.dcm)
      }
  }
}

export function editDcmReducer(state = {}, action) {
  switch ( action.type ) {
    case 'UPDATE_DCM_SUCCESS':
      return {
        dcm: {
          type: action.type,
          message: action.data
        }
      }
    case 'UPDATE_DCM_FAILURE':
      return {
        dcm: {
          type: action.type,
          message: action.data
        }
      }
    default:
      return {
        dcm: (!state.dcm ? {} : state.dcm)
      }
  }
}